var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 9 5.268 7.484.316 11.729c.18.167.423.271.691.271h11.986c.267 0 .509-.104.688-.271L8.732 7.484z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.684 2.271A1 1 0 0 0 12.993 2H1.007c-.267 0-.509.104-.689.273L7 8zM0 2.878v8.308l4.833-4.107zm9.167 4.201L14 11.186V2.875z"
  })));
};
export default SvgEmail;